import React, { memo as Memo, useMemo, useEffect } from 'react'
import { useRouter } from 'next/router'

//* HOCs
import { withUIContext } from 'context'

//* Components
import Text from 'components/common/Text'

//* Style
import PopupStyle from './style'

const Popup = Memo(({ closePopup, popupIsOpen, popupComponent, ...props }) => {
	const Child = useMemo(() => typeof popupComponent === 'string' && components[popupComponent] && components[popupComponent], [popupComponent])

	const router = useRouter()

	return popupIsOpen ? (
		<PopupStyle className='FlexBox AlignCenter'>
			<div className='popup-background' onClick={closePopup} />
			<div className='popup-content-container FlexBox AlignMiddle'>
				<div className='popup-content-wrap relativeWrap'>
					<div className='close FlexBox AlignMiddle AlignCenter cursorPointer' onClick={closePopup}>
						<Text className='h10 maisonSemiBold' text='close' />
					</div>
					{typeof popupComponent === 'string' ? <Child /> : popupComponent}
				</div>
			</div>
		</PopupStyle>
	) : null
})

export default withUIContext(Popup, ['closePopup', 'popupIsOpen', 'popupComponent'])
